import React, { useCallback, useEffect, useState } from 'react';
import CustomDataGrid from '../../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import { Icon } from '@iconify/react';
import * as yup from 'yup';
import nodata from '../../../../../../app/assets/images/nodata.png.png';
import { Box, Dialog, Switch, Tooltip, Typography } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import UpdateGeneratedTrip from '../UpdateGeneratedTrip';
import { capitalizeFirstLetter, debounce } from '../../../../../../utils/commonFunctions';
import CustomSelect from '../../../../../../common/components/customized/customselect/CustomSelect';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import CustomButton from '../../../../../../common/components/buttons/CustomButton';
import UpdatePVTGRP from '../UpdatePvtGrp';
import AddExternalVehicle from './AddExternalVehicle';
import CustomIconButton from '../../../../../../common/components/buttons/CustomIconButton';
import CustomTextField from '../../../../../../common/components/customized/customtextfield/CustomTextField';
import {
  clearExcelView,
  clearWhatsapp,
  driverDropdownAction,
  getExcelAction,
  getScheduleDriverAction,
  getStandardVehicles,
  guestContactUpdateAction,
  sendwhatsappAction
} from '../../../../redux/reducer/autoPlannerSlices/autoGenerateSlice';
import { getAgent } from '../../../../redux/reducer/autoPlannerSlices/agentslice';
import { GridActionsCellItem } from '@mui/x-data-grid';
import PhoneNoTextField from '../../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import {
  clearContactError,
  contactNumberValidation
} from '../../../../redux/reducer/autoPlannerSlices/autoplanner';
import { debounce as Debounce } from 'lodash';

interface Props {
  scheduleDate: number;
  initialLoad: boolean;
  tripPayload: any;
  agent: any;
  guest: any;
  tour: any;
  vehicle: any;
  setSearchPayload: any;
}

interface Column {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  align?: string;
  renderCell?: (params: { row: any }) => any;
  textAlign?: string;
  sortable: boolean;
}

const ExcelView = ({
  scheduleDate,
  initialLoad,
  tripPayload,
  agent,
  vehicle,
  guest,
  tour,
  setPayload,
  setSearchPayload
}: any) => {
  const [rows, setRows] = useState([]);
  const [invalidRows, setInvalidRows] = useState([]);
  const [isDate, setIsDate] = useState<boolean>(true);
  const [prevSearch, setPrevSearch] = useState(false);
  const [guestContactList, setGuestContactList] = useState<
    {
      autoplannerID: number;
      guestContactNumber: string;
      journyId: string;
    }[]
  >([]);
  const [PageSize, setPageSize] = useState(20);
  const [PageNo, setPageNo] = useState(1);
  const [filterPayload, setFilterPayload] = useState<any>('');
  const [searchEvent, setSearchEvent] = useState<any>('');
  const [filter, setFilter] = useState('');
  const [rowCount, setRowCount] = useState(0);

  const [only, setOnly] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [selectedTripRow, setSelectedTripRow] = useState<any | null>(null);
  const [driverPayload, setDriverPayload] = useState<any | null>(null);
  const [excelPayload, setExcelPayload] = useState<any>(null);
  const [isDialog, setIsDialog] = useState('');
  const [transRow, setTransRow] = useState<any | null>(null);

  const autoplannerID = scheduleDate;

  const Agents = useAppSelector(state => state.autoPlannerAgent.data || []);
  const { data: role } = useAppSelector(state => state.auth);
  const { isLoading: changeLoad } = useAppSelector(state => state.changeDriver);
  const [bookingUpdate, IsbookingsUpdate] = useState(false);
  const transferDrivers = useAppSelector(state => state.Driverdrop || []);
  const Routes = useAppSelector(state => state.autoPlannerRoutes.data || []);
  const sendwhatsapp = useAppSelector(state => state.sendwhatsapp);
  const { isLoading: driverLoading } = useAppSelector(
    state => state.AutoGeneratedUpdateTrip
  );
  const { isLoading: vehicleLoading, data: vehicleListData } = useAppSelector(
    state => state.getStandardVehicles
  );

  const contactError = useAppSelector(state => state.ContactNumberValidation);

  let roletype = role?.role;
  const roleAgent = roletype === 'ROLE_AGENT';
  const APsubAgent = roletype === 'ROLE_SUB_AGENT';

  const { data, count, isLoading } = useAppSelector(state => state.getExcel);
  const dispatch = useAppDispatch();

  const openMenu = Boolean(anchorEl);

  const hotelLocationList = selectedTripRow
    ? selectedTripRow?.mainHotelResponses?.map((item: any) => ({
        id: item.coordinates.locationAddress,
        label: item.coordinates.locationAddress
      }))
    : transRow
    ? transRow?.mainHotelResponses?.map((item: any) => ({
        id: item.coordinates.locationAddress,
        label: item.coordinates.locationAddress
      }))
    : [];
  const vehicleList = vehicleListData?.map((item: any) => ({
    id: item,
    label: item?.toUpperCase()
  }));

  const agentNames =
    Agents?.map((value: string) => ({
      id: value,
      label: capitalizeFirstLetter(value)
    })) || [];

  const configuredRoute =
    Routes?.map((value: string) => ({
      id: value,
      label: value
    })) || [];

  const dropDriver =
    transferDrivers?.data?.map((driver: any) => ({
      id: driver.driverID,
      label: capitalizeFirstLetter(driver.driverName)
    })) || [];

  const {
    control,
    setValue,
    getValues,
    formState: { errors },
    trigger
  } = useForm({});

  const handleMenuTripClick = (row: any) => {
    setSelectedTripRow(row);
  };

  const handleUpdateTrip = () => {
    IsbookingsUpdate(true);
    handleMenuClose();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    dispatch(clearWhatsapp());
    setIsDialog('');
    reset();
    setOnly(false);
  };

  const handleInvalidClose = () => {
    dispatch(clearWhatsapp());
    setIsDialog('');
    const payload = {
      ...tripPayload,
      ...filterPayload,
      PageNo: 1,
      PageSize: PageSize,
      autoplannerID: scheduleDate,
      tripMode: 'ALL',
      agentName: agent,
      guestName: guest,
      tourName: tour,
      vehicleNumber: vehicle
    };
    dispatch(getExcelAction(payload));
  };

  //function to handle add transfer
  const handleAddTransfer = async () => {
    handleMenuClose();
    const row = selectedTripRow;
    setIsDialog('addTransfer');
    const payload = {
      autoplannerID: scheduleDate,
      journeyId: row?.journeyId,
      tripMode: 'TRANSFER',
      totalPassengers: row?.totalCount,
      vehicleNumber: row?.vehicleNumber,
      tourName: row?.tourName
    };
    await dispatch(getStandardVehicles(payload));
  };

  //function to handle update transfer
  const handleTransClick = () => {
    handleMenuClose();
    const row = selectedTripRow;
    setSelectedTripRow(null);
    setTransRow(row);
    setIsDialog('Transfer');
  };

  const Driver = () =>
    yup.object().shape({
      driver: yup.string().required('Select Driver Name')
    });

  const {
    control: driverControl,
    handleSubmit: driverHandleSubmit,
    reset
  } = useForm({
    resolver: yupResolver(Driver())
  });

  useEffect(() => {
    const filter = {
      ...tripPayload,
      autoplannerID: scheduleDate,
      tripMode: 'ALL',
      PageNo: PageNo,
      PageSize: PageSize,
      agentName: agent,
      guestName: guest,
      tourName: tour,
      vehicleNumber: vehicle
    };
    setFilterPayload(filter);
  }, [agent, guest, tour, vehicle]);

  const handleDriver = (row: any) => {
    setSelectedRow(row);

    const payload = {
      mode: row?.mode,
      date: scheduleDate,
      journeyId: row?.journeyId,
      vehicleNumber: row?.vehicleNumber,
      tourName: row?.tourName,
      radio: only
    };

    setDriverPayload(payload);
    dispatch(driverDropdownAction(payload));
  };

  const handleFilterChange = useCallback(
    debounce((event: string) => {
      setFilter(event);
      setPrevSearch(true);
      const payload = {
        ...tripPayload,
        ...filterPayload,
        PageNo: 1,
        PageSize: PageSize,

        autoplannerID: scheduleDate,
        tripMode: 'ALL',
        agentName: agent,
        guestName: guest,
        tourName: tour,
        vehicleNumber: vehicle,
        searchFor: event
      };

      setSearchEvent(event);
      dispatch(getExcelAction(payload));
      const filters = {
        autoplannerID: scheduleDate,
        tripMode: 'ALL',
        PageNo: 1,
        PageSize: PageSize,
        agentName: agent,
        guestName: guest,
        tourName: tour,
        vehicleNumber: vehicle,
        searchFor: event
      };

      const search = {
        autoplannerID: scheduleDate,
        tripMode: 'ALL',
        PageNo: 1,
        PageSize: PageSize,
        searchFor: event
      };
      setFilterPayload(filters);
      setSearchPayload(search);
    }),
    [scheduleDate, tripPayload, PageNo, PageSize, filterPayload]
  );

  const columns: Column[] = [
    ...(!roleAgent && !APsubAgent
      ? [
          {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            sortable: false,
            getActions: (params: any) => {
              const isAddTrans =
                !selectedTripRow?.isReturnTrip &&
                selectedTripRow?.mainHotelResponses?.length !== 0 &&
                !selectedTripRow?.transferInstance &&
                selectedTripRow?.mode !== 'PVT' &&
                selectedTripRow?.mode! == 'GRP';
              const isTrans =
                !selectedTripRow?.isReturnTrip &&
                selectedTripRow?.mainHotelResponses?.length !== 0 &&
                selectedTripRow?.transferInstance &&
                selectedTripRow?.mode !== 'PVT' &&
                selectedTripRow?.mode !== 'GRP';

              return params?.row?.mode === 'RLR'
                ? [
                    <GridActionsCellItem
                      // disabled
                      sx={{ marginLeft: '10px' }}
                      icon={
                        <Tooltip title='RLR Tour cannot be Updated'>
                          <span>
                            <Icon
                              icon='ic:round-lock'
                              className='menu-icon update'
                              color='grey'
                              height='20'
                              width='20'
                            />
                          </span>
                        </Tooltip>
                      }
                      label='Not Editable'
                    />
                  ]
                : [
                    <GridActionsCellItem
                      icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
                      label={'Update'}
                      onClick={() => {
                        handleMenuTripClick(params.row);
                        handleUpdateTrip();
                      }}
                      showInMenu
                    />,
                    isAddTrans ? (
                      <GridActionsCellItem
                        icon={
                          <Icon
                            icon='fluent:tab-add-20-filled'
                            className='menu-icon transfer'
                          />
                        }
                        label={' Add Transfer'}
                        onClick={() => {
                          handleMenuTripClick(params.row);
                          handleAddTransfer();
                        }}
                        showInMenu
                      />
                    ) : null,
                    isTrans ? (
                      <GridActionsCellItem
                        icon={
                          <Icon
                            icon='fluent:vehicle-car-profile-16-filled'
                            className='menu-icon transfer'
                          />
                        }
                        label={'Transfer Details'}
                        onClick={() => {
                          handleMenuTripClick(params.row);
                          handleTransClick();
                        }}
                        showInMenu
                      />
                    ) : null
                    // <GridActionsCellItem
                    //   icon={
                    //     <Icon
                    //       icon='ic:outline-delete'
                    //       className='menu-icon'
                    //       style={{ color: '#FF4343' }}
                    //     />
                    //   }
                    //   label={'Delete'}
                    //   onClick={() => {
                    //     setIsDialog('DeleteBooking');
                    //     handleMenuTripClick(params.row);
                    //     handleMenuClose();
                    //   }}
                    //   showInMenu
                    // />
                  ].filter(Boolean);
            }
          }
        ]
      : []),

    {
      field: 'time',
      headerName: 'Time',
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        let timeStr = params.value;

        if (!timeStr) return '';

        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
      }
    },

    { field: 'agentName', headerName: 'Agent', minWidth: 150, flex: 1, sortable: false },
    { field: 'mode', headerName: 'Mode', minWidth: 100, flex: 1, sortable: false },
    {
      field: 'refNumber',
      headerName: 'Ref No.',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.value || '-'}>
          <span>{params.value || '-'}</span>
        </Tooltip>
      )
    },

    {
      field: 'guestName',
      headerName: 'Guest',
      minWidth: 220,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    },
    {
      field: 'adultCount',
      headerName: 'Adult Count',
      minWidth: 100,
      flex: 1,
      sortable: false
    },
    {
      field: 'childCount',
      headerName: 'Child Count',
      minWidth: 100,
      flex: 1,
      sortable: false
    },
    {
      field: 'source',
      headerName: 'From',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.row.source} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.source}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'To',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.row.destination} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.destination}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'trfOrGuide',
      headerName: 'Transfer / Guide',
      minWidth: 300,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.row.trfOrGuide} arrow>
          <Box sx={{ fontWeight: 'bold' }}>{params.row.trfOrGuide ?? '-'}</Box>
        </Tooltip>
      )
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      minWidth: 150,
      sortable: false,
      cellClassName: (params: any) => {
        const isDriverChanges = params.row.driverModified;
        if (isDriverChanges) return 'super-app-theme--cell';
      },
      renderCell: (params: any) => {
        const isDriverChanges = params.row.driverModified;
        const tooltipTitle = 'Driver details has been modified.';

        const cellContent = (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {!roleAgent && !APsubAgent && params?.row?.mode !== 'RLR' ? (
              <Tooltip
                title={
                  params?.row?.vehicleNumber === 'Unassigned'
                    ? `Can't update driver without assigning vehicle.`
                    : ''
                }
              >
                <Icon
                  icon='ph:user-switch'
                  style={{
                    color: '#232323',
                    cursor: 'pointer',
                    fontSize: '25px',
                    marginRight: '10px'
                  }}
                  className={'activeIcon'}
                  onClick={event => {
                    event.stopPropagation();
                    if (params?.row?.vehicleNumber&&params?.row?.vehicleNumber !== 'Unassigned') {
                      setIsDialog('changeDriver');
                      handleDriver(params.row);
                    }
                  }}
                />
              </Tooltip>
            ) : (
              !roleAgent &&
              !APsubAgent && (
                <Tooltip
                  title='Unable to change the driver for RLR mode.'
                  placement='top'
                  arrow
                >
                  <Icon
                    icon='material-symbols:info-rounded'
                    style={{
                      color: '#7c7c7c',
                      cursor: 'pointer',
                      fontSize: '20px',
                      marginRight: '10px'
                    }}
                    onClick={event => {
                      event.stopPropagation();
                    }}
                  />
                </Tooltip>
              )
            )}

            <Typography sx={{ fontSize: '0.75rem' }}>{params.value}</Typography>
          </Box>
        );

        return isDriverChanges ? (
          <Tooltip title={tooltipTitle} placement='top' arrow>
            <span>{cellContent}</span>
          </Tooltip>
        ) : (
          cellContent
        );
      },
      flex: 1
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle No',
      minWidth: 100,
      flex: 1,
      sortable: false,
      cellClassName: (params: any) => {
        const isVehicleChanges = params.row.vehicleModified;
        return isVehicleChanges ? 'super-app-theme--cell' : '';
      },
      renderCell: (params: any) => {
        const isVehicleChanges = params.row.vehicleModified;
        const tooltipTitle = 'Vehicle details has been modified.';
        const displayValue =
          params.value?.toLowerCase() === 'unassigned'
            ? 'Unassigned'
            : params.value?.toUpperCase();

        return isVehicleChanges ? (
          <Tooltip title={tooltipTitle} placement='top' arrow>
            <span>{displayValue}</span>
          </Tooltip>
        ) : (
          <span>{displayValue}</span>
        );
      }
    },
    {
      field: 'driverContactNumber',
      headerName: 'Driver Contact No',
      minWidth: 150,
      flex: 1,
      sortable: false
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  const handleGuestContactChange = Debounce(async (event: any, journey: any) => {
    if (!event) {
      handleGuestContactChange.cancel();
      setInvalidRows((prev: any) => {
        const updatedRows = prev?.map((item: any) => ({
          ...item,
          color: item?.journeyID === journey ? '' : item?.color,
          contactNumber: item?.journeyID === journey ? '' : item?.contactNumber,
          isError: item?.journeyID === journey ? false : item?.isError
        }));
        return updatedRows;
      });
    }

    if (event) {
      let action1 = await dispatch(contactNumberValidation(event));

      if (action1?.payload) {
        setInvalidRows((prev: any) => {
          const updatedRows = prev?.map((item: any) => ({
            ...item,
            color:
              item?.journeyID === journey
                ? action1?.payload?.status !== 200
                  ? '#ff07078c'
                  : ''
                : item?.color,
            contactNumber: item?.journeyID === journey ? event : item?.contactNumber,
            isError:
              item?.journeyID === journey && event
                ? action1?.payload?.status !== 200
                : item?.isError
          }));

          return updatedRows;
        });
      }
    }
  }, 500);

  const handleUpdateContact = async () => {
    const filteredRows = invalidRows?.filter((item: any) => item?.contactNumber);

    const payloadData = filteredRows?.map((item: any) => ({
      autoplannerID,
      guestContactNumber: item?.contactNumber,
      journyId: item?.journeyID
    }));
    await dispatch(guestContactUpdateAction(payloadData));
    setGuestContactList([]);
    const payload = {
      autoplannerId: scheduleDate
    };
    dispatch(sendwhatsappAction(payload));
  };

  useEffect(() => {
    return () => {
      dispatch(clearContactError());
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearWhatsapp());
    };
  }, []);

  const invalidColumns: any[] = [
    {
      field: 'time',
      headerName: 'Time',
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        let timeStr = params.value;

        if (!timeStr) return '';

        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
      }
    },

    { field: 'agentName', headerName: 'Agent', minWidth: 150, flex: 1, sortable: false },
    { field: 'mode', headerName: 'Mode', minWidth: 100, flex: 1, sortable: false },
    {
      field: 'refNumber',
      headerName: 'Ref No.',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value ? params.value : '-'}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestName',
      headerName: 'Guest',
      minWidth: 220,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value ? params.value : '-'}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 250,
      flex: 1,
      renderCell: (params: any) => {
        const row: any = params.row as { journeyId: string };
        const journyId = row.journeyID;

        return (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              overflow: 'hidden',
              px: 1
            }}
          >
            <Controller
              name='phone'
              control={control}
              defaultValue={''}
              rules={{ required: true }}
              render={({ field }: any) => {
                return (
                  <PhoneNoTextField
                    setValue={setValue}
                    name='phone'
                    isOptional={true}
                    margin='2px'
                    style='share'
                    // label='Contact Number'
                    onChange={(e: any) => {
                      handleGuestContactChange(e, journyId);
                    }}
                  />
                );
              }}
            />
          </Box>
        );
      }
    },

    {
      field: 'source',
      headerName: 'From',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.row.source} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.source}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'To',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title={params.row.destination} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.destination}
          </Box>
        </Tooltip>
      )
    },

    {
      field: 'vehicleNumber',
      headerName: 'Vehicle No',
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: ({ value }: any) =>
        value?.toLowerCase() === 'unassigned' ? value : value?.toUpperCase()
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  const handlePaginationModelChange = async (newPaginationModel: any) => {
    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);
    const newPage = newPageNo + 1;
    const payload = {
      ...filterPayload,
      PageNo: newPage,
      PageSize: newPageSize,
      autoplannerID: scheduleDate,
      tripMode: 'ALL',
      searchFor: searchEvent ? searchEvent : ''
    };

    dispatch(getExcelAction(payload));
  };

  const handleUpdateTransfer = async () => {
    setIsDialog('addTransfer');
    const payload = {
      autoplannerID: scheduleDate,
      journeyId: transRow.journeyId,
      tripMode: 'TRANSFER',
      tourName: transRow?.tourName,
      totalPassengers: transRow?.totalCount,
      vehicleNumber: transRow?.transferInstance?.vehicleNumber
        ? transRow?.transferInstance?.vehicleNumber
        : ''
    };

    await dispatch(getStandardVehicles(payload));
  };

  const handleSkip = async () => {
    const payload = {
      autoplannerId: scheduleDate,
      skippingPhoneNumber: true
    };
    await dispatch(sendwhatsappAction(payload));
    dispatch(clearWhatsapp());
    setIsDialog('');
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setOnly(isChecked);
    const payload = {
      ...driverPayload,
      radio: isChecked,
      modifyVehicleDriver: only
    };
    dispatch(driverDropdownAction(payload));
  };

  const onChangeDriverSubmit = async (params: any) => {
    const payload = {
      ...selectedRow,
      ...driverPayload,
      modifyVehicleDriver: only ? 0 : 1,
      driverID: params.driver
    };

    const action = await dispatch(getScheduleDriverAction(payload));

    if (action.type === getScheduleDriverAction.fulfilled.type) {
      const paramss = {
        ...filterPayload,
        autoplannerID: scheduleDate,
        tripMode: 'ALL',
        PageNo: PageNo,
        PageSize: PageSize
      };
      handleClose();
      setSelectedTripRow(null);
      await dispatch(getExcelAction(paramss));
    }
    handleClose();
    reset();
  };

  useEffect(() => {
    if (data?.length === 0) {
      setRows([]);
    }

    if (data?.length > 0) {
      const getExcel = data?.map((item: any, index: number) => ({
        ...item,
        id: index + 1,
        driver: item.driverName + ' - ' + item.driverContactNumber,
        totalCount: item?.adultCount + item?.childCount,
        color: `#${item?.colour?.substring(2)}`,
        trfOrGuide:
          item.transferInstance !== null
            ? `TRF BY ${
                item.transferInstance?.driverName
              } ${item.transferInstance?.vehicleNumber?.toUpperCase()} ${
                item?.transferInstance.contactNumber
              }`
            : item.guideName
            ? `GUIDE ${item.guideName} ${item.guideContactNumber}`
            : '-'
      }));
      dispatch(getAgent);
      setRows(getExcel);
      setRowCount(count);
    } else {
      setRows([]);
    }
  }, [data]);

  useEffect(() => {
    if (sendwhatsapp?.data?.data?.length === 0) {
      setRows([]);
    }

    if (sendwhatsapp?.data?.data?.length > 0) {
      const invalidContact = sendwhatsapp?.data?.data?.map(
        (item: any, index: number) => ({
          ...item,
          id: index + 1,
          isError: false,
          contactNumber: '',
          color: `#fff`
        })
      );

      setInvalidRows(invalidContact);
    } else {
      setInvalidRows([]);
    }
  }, [sendwhatsapp?.data?.data]);

  useEffect(() => {
    if (initialLoad) {
      setPageNo(1);
      setPageSize(20);
    }
  }, [initialLoad]);

  useEffect(() => {
    setIsDate(true);
  }, [scheduleDate]);

  useEffect(() => {
    if (scheduleDate !== 0 && isDate) {
      const payload = {
        autoplannerID: scheduleDate,
        tripMode: 'ALL',
        PageNo: PageNo,
        PageSize: PageSize
      };
      setExcelPayload(payload);
      dispatch(getExcelAction(payload));
      setIsDate(false);
    }
    return () => {
      dispatch(clearExcelView());
    };
  }, [isDate, scheduleDate]);

  useEffect(() => {
    setPayload({ pageNo: PageNo, pageSize: PageSize });
  }, [PageNo, PageSize]);

  useEffect(() => {
    setValue('search', '');
  }, [scheduleDate]);

  useEffect(() => {
    if (sendwhatsapp?.data?.count > 0) {
      setIsDialog('Nocontact');
    }
  }, [sendwhatsapp]);
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
        {(rows?.length > 0 || filter) && (
          <Box sx={{ width: 200 }}>
            <CustomTextField
              name='search'
              control={control}
              id='filter-input'
              placeholder='Search...'
              value={filter}
              variant='standard'
              icon={<SearchOutlinedIcon color='primary' />}
              onChangeCallback={(e: any) => handleFilterChange(e)}
            />
          </Box>
        )}
      </Box>
      {isLoading && data?.length === 0 ? (
        <Box className='blue-circle-loader big-screen'>
          <Box className='blue-circle-spinner'></Box>
        </Box>
      ) : data?.length > 0 && rows ? (
        <CustomDataGrid
          rows={rows}
          columns={columns}
          type='logistics'
          onPaginationModelChange={handlePaginationModelChange}
          pageNo={PageNo}
          rowCount={rowCount}
          loading={isLoading}
          pageSize={PageSize}
          paginationModel={{
            page: PageNo ? PageNo - 1 : 0,
            pageSize: PageSize || 20
          }}
        />
      ) : (
        <Box className='no-report-img'>
          <Box
            component='img'
            src={nodata}
            alt='No Report Found'
            className='no-report-found'
          />
        </Box>
      )}
      {bookingUpdate &&
      (selectedTripRow.mode === 'SIC' || selectedTripRow.mode === 'TSIC') ? (
        <UpdateGeneratedTrip
          isOpen={bookingUpdate}
          setIsOpen={IsbookingsUpdate}
          selectedTripRow={selectedTripRow}
          setSelectedTripRow={setSelectedTripRow}
          selectedRow={selectedRow}
          excelPayload={excelPayload}
          autoplannerID={scheduleDate}
          pageDetail={{ pageNo: PageNo, pageSize: PageSize }}
          tripMode={selectedTripRow?.mode}
          Agents={agentNames}
          Routes={configuredRoute}
        />
      ) : (
        ''
      )}
      {bookingUpdate &&
      (selectedTripRow.mode === 'PVT' || selectedTripRow.mode === 'GRP') ? (
        <UpdatePVTGRP
          isOpen={bookingUpdate}
          setIsOpen={IsbookingsUpdate}
          filterPayload={filterPayload}
          selectedTripRow={selectedTripRow}
          selectedRow={selectedRow}
          excelPayload={excelPayload}
          autoplannerID={scheduleDate}
          pageDetail={{ pageNo: PageNo, pageSize: PageSize }}
          tripMode={selectedTripRow?.mode}
          Agents={agentNames}
        />
      ) : (
        ''
      )}
      <Dialog
        open={isDialog === 'changeDriver'}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: 'linear-gradient(to bottom, #ffffff, #f0f8ff)',
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden'
          }
        }}
      >
        <Box
          padding={3}
          width={400}
          component={'form'}
          onSubmit={driverHandleSubmit(onChangeDriverSubmit)}
        >
          <Typography sx={{ fontWeight: '600', fontSize: '18px' }}>
            Change Driver
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '5px',
              marginRight: '10px'
            }}
          >
            <Typography>Changes only applicable for this tour </Typography>
            <Switch
              checked={only}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </Box>
          <CustomSelect
            id='driver'
            control={driverControl}
            name='driver'
            label='Driver Name'
            placeholder='Select Driver Name'
            options={dropDriver}
            loading={transferDrivers.isLoading}
          />
          <Box sx={{ textAlign: 'right', padding: '10px' }}>
            <CustomButton
              category='Cancel'
              className='cancel'
              sx={{ marginRight: '10px' }}
              onClick={() => handleClose()}
            />
            <CustomButton
              category={'Save'}
              className='saveChanges'
              type='submit'
              loading={changeLoad}
            />
          </Box>
        </Box>
      </Dialog>
      {isDialog === 'Transfer' && (
        <Dialog
          open={isDialog === 'Transfer'}
          onClose={handleClose}
          PaperProps={{
            sx: {
              borderRadius: 3,
              background: 'linear-gradient(to bottom, #ffffff, #f0f8ff)',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
              overflow: 'hidden'
            }
          }}
        >
          <Box padding={3} width={400} position='relative'>
            <Box
              className='closeIcon icon-position d-flex close-icon-index'
              onClick={() => handleClose()}
            >
              <CustomIconButton category='CloseValue' />
            </Box>

            <Typography
              variant='h6'
              sx={{
                marginBottom: 2,
                fontWeight: 'bold',
                color: '#333',
                textAlign: 'center',
                textTransform: 'uppercase',
                borderBottom: '2px solid #007bff',
                paddingBottom: 1
              }}
            >
              Transfer Details
            </Typography>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Transfer From:</strong>{' '}
                {transRow?.transferInstance?.from?.locationAddress}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Transfer To:</strong>{' '}
                {transRow?.transferInstance?.to?.locationAddress}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Total Count:</strong> {transRow?.transferInstance?.totalCount}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Driver Name:</strong> {transRow?.transferInstance?.driverName}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Contact Number:</strong>{' '}
                {transRow?.transferInstance?.contactNumber}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Vehicle Number:</strong>{' '}
                {transRow?.transferInstance?.vehicleNumber?.toUpperCase()}
              </Typography>
            </Box>
            <Box sx={{ ml: '280px' }}>
              <CustomButton
                className='saveChanges'
                category='Update'
                onClick={() => {
                  handleUpdateTransfer();
                }}
              />
            </Box>
          </Box>
        </Dialog>
      )}
      {isDialog == 'Nocontact' && (
        <Dialog
          open={isDialog == 'Nocontact'}
          onClose={handleClose}
          maxWidth='xl'
          fullWidth
          PaperProps={{
            sx: {
              width: '90vw',
              maxWidth: '1400px',
              height: '85vh',
              maxHeight: '800px',
              borderRadius: '16px',
              boxShadow: '0 24px 48px rgba(0, 0, 0, 0.15)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              overflow: 'hidden'
            }
          }}
        >
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative'
            }}
          >
            <Box
              sx={{
                padding: '10px 32px ',
                borderBottom: '1px solid #e2e8f0',
                background: 'linear-gradient(90deg, #f1f5f9 0%, #ffffff 100%)',
                position: 'relative',
                flexShrink: 0
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  padding: '12px 16px',
                  backgroundColor: '#fffbeb',
                  border: '1px solid #fed7aa',
                  borderRadius: '12px',
                  marginBottom: '16px',
                  boxShadow: '0 2px 4px rgba(251, 191, 36, 0.1)'
                }}
              >
                <Box
                  sx={{
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    backgroundColor: '#f59e0b',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    marginTop: '2px'
                  }}
                >
                  !
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant='body1'
                    sx={{
                      color: '#92400e',
                      fontSize: '12px',
                      lineHeight: 1.6,
                      fontWeight: 500,
                      margin: 0
                    }}
                  >
                    Some of these bookings do not have contact numbers. You may either add
                    the missing numbers or proceed by clicking the 'Skip' button to send
                    WhatsApp messages to the bookings with valid contact numbers.
                  </Typography>
                </Box>

                <CustomButton
                  className='skip'
                  category='Skip & Send'
                  onClick={() => {
                    handleSkip();
                  }}
                  sx={{
                    minWidth: '100px',
                    height: '36px',
                    borderRadius: '6px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.825rem',
                    border: '2px solid #f59e0b',
                    color: '#f59e0b',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 2px 4px rgba(245, 158, 11, 0.15)',
                    '&:hover': {
                      backgroundColor: '#fef3c7',
                      borderColor: '#d97706',
                      color: '#d97706',
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 8px rgba(245, 158, 11, 0.25)'
                    },
                    transition: 'all 0.2s ease'
                  }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                flex: 1,
                // padding: 'px 28px',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                overflow: 'hidden'
              }}
            >
              <Box
                sx={{
                  height: '200vh',
                  borderRadius: '12px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  background: '#ffffff',
                  overflow: 'auto'
                }}
              >
                <Box
                  key={invalidRows?.length}
                  sx={{
                    height: '100%',
                    width: '100%',
                    '& .MuiDataGrid-root': {
                      border: 'none',
                      height: '100%'
                    },
                    '& .MuiDataGrid-main': {
                      overflow: 'visible'
                    },
                    '& .MuiDataGrid-virtualScroller': {
                      overflow: 'auto !important',
                      height: 'auto !important'
                    },
                    '& .MuiDataGrid-footerContainer': {
                      minHeight: '52px',
                      borderTop: '1px solid #e2e8f0',
                      backgroundColor: '#f8fafc'
                    },
                    '& .MuiDataGrid-row:hover': {
                      backgroundColor: '#f1f5f9'
                    }
                  }}
                >
                  <CustomDataGrid
                    rows={invalidRows}
                    columns={invalidColumns}
                    loading={isLoading}
                    rowHeight={40}
                    type={'noPageNation'}
                    paginationMode={'client'}
                  />
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                padding: '20px 32px 24px',
                borderTop: '1px solid #e2e8f0',
                background: 'linear-gradient(90deg, #ffffff 0%, #f8fafc 100%)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexShrink: 0
              }}
            >
              <Box sx={{ display: 'flex', gap: '16px' }}>
                <CustomButton
                  className='cancel'
                  category='Cancel'
                  onClick={() => {
                    reset();
                    handleInvalidClose();
                  }}
                  sx={{
                    minWidth: '120px',
                    height: '44px',
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '0.925rem',
                    border: '2px solid #e2e8f0',
                    color: '#64748b',
                    backgroundColor: '#ffffff',
                    '&:hover': {
                      backgroundColor: '#f8fafc',
                      borderColor: '#cbd5e1',
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                    },
                    transition: 'all 0.2s ease'
                  }}
                />

                <CustomButton
                  className='saveChanges'
                  type='submit'
                  disabled={invalidRows?.some((item: any) => item?.isError)}
                  category='Update'
                  onClick={() => handleUpdateContact()}
                  sx={{
                    minWidth: '120px',
                    height: '44px',
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.925rem',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                    color: '#ffffff',
                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 20px rgba(59, 130, 246, 0.4)'
                    },
                    transition: 'all 0.2s ease',
                    '&:disabled': {
                      background: '#94a3b8',
                      transform: 'none',
                      boxShadow: 'none'
                    }
                  }}
                />
              </Box>

              {invalidRows?.some((item: any) => item?.isError) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Box
                    sx={{
                      width: 15,
                      height: 15,
                      borderRadius: '50%',
                      backgroundColor: '#ff07078c'
                    }}
                  />
                  <p
                    style={{
                      color: '#5e5c5cff',
                      fontSize: '14px',
                      fontWeight: 600,
                      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                    }}
                  >
                    Invalid Contact Numbers :{' '}
                    {invalidRows?.filter((item: any) => item?.isError)?.length}
                  </p>
                </Box>
              )}
            </Box>
          </Box>
        </Dialog>
      )}

      {isDialog === 'addTransfer' && (
        <AddExternalVehicle
          selectedRow={selectedTripRow}
          isDialog={isDialog}
          transRow={transRow}
          setTransRow={setTransRow}
          setAnchorEl={setAnchorEl}
          setIsDialog={setIsDialog}
          hotelLocationList={hotelLocationList}
          vehicleList={vehicleList}
          tripMode={'ALL'}
          scheduleDate={scheduleDate}
        />
      )}
    </>
  );
};

export default ExcelView;
